module.exports = __webpack_public_path__ + "media/images/server-error-d163db9695737ab5c4729d8f5bd9cb33.svg";